(function() {
    const params = new URLSearchParams(window.location.search);
    const cid = params.get('cid');
    const hash = params.get('hash');

    if (!cid || !hash) return;

    const GIFT_VARIANT_ID = 46829797081309;

    // Update button states based on gift status in cart
    async function updateButtonStates() {
        let giftInCart = false;
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            giftInCart = cart.items.some(item => item.variant_id === GIFT_VARIANT_ID);
        } catch (e) {
            console.error('Error checking cart:', e);
        }

        const addButtons = document.querySelectorAll('[data-add-btn]');
        const checkoutButtons = document.querySelectorAll('[data-checkout-btn]');
        const browseButtons = document.querySelectorAll('[data-browse-btn]');
        const successBoxes = document.querySelectorAll('[data-success-box]');
        const pendingSections = document.querySelectorAll('[data-pending-section]');

        // Toggle success/pending states based on gift in cart
        if (giftInCart) {
            successBoxes.forEach(box => box.classList.add('is-visible'));
            pendingSections.forEach(section => section.classList.add('is-hidden'));
            addButtons.forEach(btn => btn.style.display = 'none');
            checkoutButtons.forEach(btn => btn.classList.add('is-visible'));
            browseButtons.forEach(btn => btn.style.display = 'none');
        } else {
            successBoxes.forEach(box => box.classList.remove('is-visible'));
            pendingSections.forEach(section => section.classList.remove('is-hidden'));
            addButtons.forEach(btn => btn.style.display = 'block');
            checkoutButtons.forEach(btn => btn.classList.remove('is-visible'));
            browseButtons.forEach(btn => btn.style.display = 'block');
        }
    }

    // Re-check cart when user returns to this tab
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') {
            updateButtonStates();
        }
    });

    document.addEventListener('click', async function(e) {
        const btn = e.target.closest('.loyalty-apply-btn');
        if (!btn) return;
        e.preventDefault();

        const discountUrl = btn.getAttribute('href');

        // Show loading state
        btn.textContent = 'Adding...';
        btn.classList.add('loyalty-apply-btn--disabled');

        try {
            // 1. Add gift to cart
            const cartRes = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
            });
            const cartData = await cartRes.json();
            console.log('Cart add:', cartRes.status, cartData);

            // 2. Apply discount code in background (sets session cookie)
            await fetch(discountUrl, { method: 'GET', credentials: 'include' });
            console.log('Discount applied:', discountUrl);

            // 3. Update UI to show success state
            updateButtonStates();

            window.location.href = '/collections/bestsellers';
        } catch (err) {
            console.error('Error adding gift:', err);
            btn.textContent = 'Add to Cart For Free';
            btn.classList.remove('loyalty-apply-btn--disabled');
        }
    });

    const url = `/apps/subscribfy-api/loyalty/store/dashboard?cid=${cid}&hash=${hash}`;

    fetch(url)
        .then(res => res.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const target = document.querySelector('.exm_membership_status_block.subscription_type_1');
            if (!target) return;

            const styles = `
                <style>
                    .loyalty-coupons-card {
                        background: #b17742;
                        border-radius: 3px;
                        padding: 24px;
                        margin-top: 20px;
                        max-width: 420px;
                        box-shadow: 4px 4px 15px 0 rgba(0, 0, 0, .3);
                        margin-left: auto;
                        margin-right: auto;
                        color: #341C09;
                        font-family: inherit;
                    }
                    .loyalty-card-header {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 16px;
                    }
                    .loyalty-card-header svg {
                        width: 20px;
                        height: 20px;
                        color: #fff;
                    }
                    .loyalty-card-header h4 {
                        font-size: 14px;
                        font-weight: 600;
                        margin: 0;
                        text-transform: uppercase;
                        letter-spacing: 1.5px;
                        color: #fff;
                    }
                    .loyalty-code-row {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        margin-bottom: 6px;
                    }
                    .loyalty-free-badge {
                        background: #341C09;
                        color: #fff;
                        font-size: 11px;
                        font-weight: 700;
                        padding: 6px 12px;
                        border-radius: 3px;
                        text-transform: uppercase;
                    }
                    .loyalty-code-box {
                        font-size: 11px;
                        color: #fff;
                        background: #341C09;
                        padding: 6px 12px;
                        border-radius: 3px;
                    }
                    .loyalty-auto-applied {
                        font-size: 12px;
                        color: #f8f8f8;
                        margin-bottom: 14px;
                    }
                    .loyalty-coupon-title {
                        font-weight: 600;
                        font-size: 16px;
                        margin-bottom: 2px;
                        color: #fff;
                    }
                    .loyalty-coupon-expires {
                        font-size: 13px;
                        color: #fff;
                        margin-bottom: 16px;
                    }
                    .loyalty-product-box {
                        background: #341C09;
                        border-radius: 3px;
                        padding: 14px;
                        display: flex;
                        align-items: center;
                        gap: 14px;
                        margin-bottom: 16px;
                    }
                    .loyalty-product-label {
                        background: #fff;
                        border: 1px solid #bbb;
                        border-radius: 3px;
                        padding: 8px 12px;
                        font-size: 14px;
                        font-weight: 500;
                        color: #341C09;
                    }
                    .loyalty-product-info {
                        flex: 1;
                        color:#fff;
                    }
                    .loyalty-product-name {
                        font-weight: 600;
                        font-size: 14px;
                        color: #fff;
                        margin-bottom: 2px;
                    }
                    .loyalty-product-free {
                        font-size: 13px;
                        color: #f8f8f8;
                    }
                    .loyalty-reminder-box {
                        background: #fef3cd;
                        border-radius: 3px;
                        padding: 14px;
                        margin-bottom: 16px;
                        display: flex;
                        gap: 5px;
                    }
                    .loyalty-reminder-icon {
                        color: #C81A1A;
                        flex-shrink: 0;
                        margin-top: 2px;
                    }
                    .loyalty-reminder-content {
                        flex: 1;
                    }
                    .loyalty-reminder-title {
                        font-weight: 600;
                        font-size: 14px;
                        color: #C81A1A;
                        margin-bottom: 4px;
                    }
                    .loyalty-reminder-text {
                        font-size: 13px;
                        color: #341C09;
                    }
                    .loyalty-apply-btn {
                        background: #341C09;
                        color: #fff;
                        padding: 14px 20px;
                        border-radius: 3px;
                        text-decoration: none;
                        font-size: 14px;
                        font-weight: 600;
                        display: block;
                        text-align: center;
                        transition: background 0.2s;
                        margin-bottom: 10px;
                    }
                    .loyalty-apply-btn:hover {
                        background: #444;
                    }
                    .loyalty-apply-btn--disabled {
                        background: #999;
                        cursor: not-allowed;
                        pointer-events: none;
                    }
                    .loyalty-browse-btn {
                        background: transparent;
                        color: #341C09;
                        padding: 12px 20px;
                        border: 2px solid #341C09;
                        border-radius: 3px;
                        text-decoration: none;
                        font-size: 14px;
                        font-weight: 600;
                        display: block;
                        text-align: center;
                        transition: background 0.2s, color 0.2s;
                    }
                    .loyalty-browse-btn:hover {
                        background: #341C09;
                        color: #fff;
                    }
                    .loyalty-success-box {
                        background: #341C09;
                        border-radius: 3px;
                        padding: 20px;
                        margin-bottom: 16px;
                        text-align: center;
                        display: none;
                    }
                    .loyalty-success-box.is-visible {
                        display: block;
                    }
                    .loyalty-success-icon {
                        color: #fff;
                        margin-bottom: 12px;
                    }
                    .loyalty-success-icon svg {
                        width: 32px;
                        height: 32px;
                    }
                    .loyalty-success-title {
                        font-weight: 600;
                        font-size: 16px;
                        color: #fff;
                        margin-bottom: 8px;
                    }
                    .loyalty-success-text {
                        font-size: 14px;
                        color: #fff;
                        margin-bottom: 4px;
                    }
                    .loyalty-success-reminder {
                        font-size: 14px;
                        color: #C81A1A;
                        font-weight: 500;
                        margin-bottom: 12px;
                    }
                    .loyalty-success-expires {
                        font-size: 13px;
                        color: #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                    }
                    .loyalty-success-expires svg {
                        width: 14px;
                        height: 14px;
                    }
                    .loyalty-pending-section {
                        display: block;
                    }
                    .loyalty-pending-section.is-hidden {
                        display: none;
                    }
                    .loyalty-checkout-btn {
                        background: #341C09;
                        color: #fff;
                        padding: 14px 20px;
                        border-radius: 3px;
                        font-size: 14px;
                        font-weight: 600;
                        display: none;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;
                        margin-bottom: 10px;
                        cursor: default;
                    }
                    .loyalty-checkout-btn.is-visible {
                        display: flex;
                    }
                    .loyalty-checkout-btn svg {
                        width: 18px;
                        height: 18px;
                        display: none;
                    }
                </style>
            `;

            // Get available coupons
            const couponsSection = doc.querySelector('#exm_coupons-available');
            if (couponsSection) {
                const couponItems = couponsSection.querySelectorAll('.exm_p-4');

                if (couponItems && couponItems.length > 0) {
                    let couponsHtml = '';

                    // SVG icons
                    const giftIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>';
                    const giftIconLarge = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>';
                    const lightbulbIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>';
                    const clockIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
                    const cartIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>';

                    couponItems.forEach(item => {
                        const codeEl = item.querySelector('[code]');
                        const code = codeEl?.getAttribute('code') || codeEl?.textContent?.trim() || '';
                        const name = item.querySelector('b')?.textContent?.trim() || 'Free Product Coupon';
                        const expires = item.querySelector('.exm_text-gray-500')?.textContent?.trim() || '';
                        const applyLink = code ? `/discount/${code}` : '#';

                        couponsHtml += `
                            <div class="loyalty-coupon-item">
                                <!-- Code row -->
                                <div class="loyalty-code-row">
                                    <span class="loyalty-free-badge">Free</span>
                                    <span class="loyalty-code-box">${code}</span>
                                </div>
                                <div class="loyalty-auto-applied">Auto-applied at checkout</div>

                                <!-- Title & expiry -->
                                <div class="loyalty-coupon-title">${name}</div>
                                <div class="loyalty-coupon-expires">${expires}</div>

                                <!-- Product box -->
                                <div class="loyalty-product-box">
                                    <div class="loyalty-product-label">Gift</div>
                                    <div class="loyalty-product-info">
                                        <div class="loyalty-product-name">Mystery Gift</div>
                                        <div class="loyalty-product-free">FREE for eligible members</div>
                                    </div>
                                </div>

                                <!-- Success box (shown when gift is in cart) -->
                                <div class="loyalty-success-box" data-success-box>
                                    <div class="loyalty-success-icon">${giftIconLarge}</div>
                                    <div class="loyalty-success-title">Gift Added Successfully!</div>
                                    <div class="loyalty-success-text">Your Mystery Gift is waiting in your cart.</div>
                                    <div class="loyalty-success-reminder">Remember to log in at checkout while to receive it!</div>
                                    <div class="loyalty-success-expires">${clockIcon} ${expires}</div>
                                </div>

                                <!-- Pending section (shown when gift is NOT in cart) -->
                                <div class="loyalty-pending-section" data-pending-section>
                                    <!-- Reminder box -->
                                    <div class="loyalty-reminder-box">
                                        <div class="loyalty-reminder-icon">${lightbulbIcon}</div>
                                        <div class="loyalty-reminder-content">
                                            <div class="loyalty-reminder-title">Important: Add another product to your cart</div>
                                            <div class="loyalty-reminder-text">To receive this free gift, you must have <span style="text-decoration:underline;">at least one other product </span> in your cart before checkout.</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Buttons -->
                                <a href="${applyLink}" class="loyalty-apply-btn" data-add-btn>Add to Cart For Free</a>
                                <span class="loyalty-checkout-btn" data-checkout-btn>${cartIcon} Added</span>
                                <a href="/collections/all" target="_blank" rel="noopener" class="loyalty-browse-btn" data-browse-btn>Browse Products</a>
                            </div>
                        `;
                    });

                    const wrapper = document.createElement('div');
                    wrapper.innerHTML = styles + `
                        <div class="loyalty-coupons-card">
                            <div class="loyalty-card-header">
                                ${giftIcon}
                                <h4>Your Coupons</h4>
                            </div>
                            ${couponsHtml}
                        </div>
                    `;
                    target.insertAdjacentElement('afterend', wrapper);

                    // Check cart eligibility and update button states
                    updateButtonStates();
                }
            }
        })
        .catch(err => console.error('Error fetching loyalty data:', err));
})();
